// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IBasePersonInfoDto } from './IBasePersonInfoDto';
import {
    IBasePersonInfoDtoFromJSON,
    IBasePersonInfoDtoFromJSONTyped,
    IBasePersonInfoDtoToJSON,
    IBasePersonInfoDtoToJSONTyped,
} from './IBasePersonInfoDto';

/**
 * 
 * @export
 * @interface IDependentInfoDto
 */
export interface IDependentInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IDependentInfoDto
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    ssn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    middle_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    suffix?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    gender?: IDependentInfoDtoGenderEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof IDependentInfoDto
     * @deprecated
     */
    birth_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IDependentInfoDto
     */
    local_date_birth_on?: Date;
    /**
     * 
     * @type {IBasePersonInfoDto}
     * @memberof IDependentInfoDto
     */
    person: IBasePersonInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    relationship_type: IDependentInfoDtoRelationshipTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    external_identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoDto
     */
    creation_source_type?: IDependentInfoDtoCreationSourceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDependentInfoDtoGenderEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}
/**
* @export
* @enum {string}
*/
export enum IDependentInfoDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}
/**
* @export
* @enum {string}
*/
export enum IDependentInfoDtoCreationSourceTypeEnum {
    UNKNOWN = 'UNKNOWN',
    API = 'API',
    MOBILE = 'MOBILE',
    WEB_PARTICIPANT_PORTAL = 'WEB_PARTICIPANT_PORTAL',
    WEB_ADMIN_PORTAL = 'WEB_ADMIN_PORTAL',
    DEPENDENT = 'DEPENDENT',
    CARRIER = 'CARRIER',
    CENSUS = 'CENSUS'
}


/**
 * Check if a given object implements the IDependentInfoDto interface.
 */
export function instanceOfIDependentInfoDto(value: object): value is IDependentInfoDto {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('relationship_type' in value) || value['relationship_type'] === undefined) return false;
    return true;
}

export function IDependentInfoDtoFromJSON(json: any): IDependentInfoDto {
    return IDependentInfoDtoFromJSONTyped(json, false);
}

export function IDependentInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDependentInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'first_name': json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'local_date_birth_on': json['local_date_birth_on'] == null ? undefined : (new Date(json['local_date_birth_on'])),
        'person': IBasePersonInfoDtoFromJSON(json['person']),
        'relationship_type': json['relationship_type'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'creation_source_type': json['creation_source_type'] == null ? undefined : json['creation_source_type'],
    };
}

export function IDependentInfoDtoToJSON(json: any): IDependentInfoDto {
    return IDependentInfoDtoToJSONTyped(json, false);
}

export function IDependentInfoDtoToJSONTyped(value?: IDependentInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ssn': value['ssn'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'gender': value['gender'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString()),
        'local_date_birth_on': value['local_date_birth_on'] == null ? undefined : ((value['local_date_birth_on']).toISOString().substring(0,10)),
        'person': IBasePersonInfoDtoToJSON(value['person']),
        'relationship_type': value['relationship_type'],
        'external_identifier': value['external_identifier'],
        'creation_source_type': value['creation_source_type'],
    };
}

